export default __webpack_public_path__ + "static/media/Invata Intralogistics.9d819781.png";